export type LoginTitle = {
  text: string
  isEnvBadge: boolean
}

// AUTH_PF_ENV から環境ごとのログイン画面タイトルを導出する。
// - prod: 「薬局ユーザーさま向けログイン」
// - demo7: 「練習用 ログイン」
// - local: 「local ログイン」（小文字のまま）
// - その他: env 名を先頭大文字にして「<Env> ログイン」（例: stg6 → Stg6 ログイン）
// isEnvBadge が true のときは赤字で表示する想定。
export const getLoginTitle = (env: string | undefined = process.env.AUTH_PF_ENV): LoginTitle => {
  if (!env || env === 'prod') {
    return { text: '薬局ユーザーさま向けログイン', isEnvBadge: false }
  }
  if (env === 'demo7') {
    return { text: '練習用 ログイン', isEnvBadge: true }
  }
  if (env === 'local') {
    return { text: 'local ログイン', isEnvBadge: true }
  }
  const capitalized = env.charAt(0).toUpperCase() + env.slice(1)
  return { text: `${capitalized} ログイン`, isEnvBadge: true }
}
